import { useUser } from 'hooks';
import { Navigate } from 'react-router-dom';

const Root = () => {
    const [loggedInUser] = useUser();

    if (loggedInUser && loggedInUser.role === 'ADMIN' && !loggedInUser.user.isSuperAdmin) {
        return <Navigate to="/aams-login" />;
    }

    const getRootUrl = () => {
        if (!loggedInUser) {
            return '/aams-login';
        }
        const { role } = loggedInUser;
        switch (role) {
            case 'ADMIN':
                return loggedInUser.user.isSuperAdmin ? '/settings' : '/simple-route';
            case 'CUSTOMER_ADMIN':
                return '/customer-admin-route';
            case 'ANALYST':
                return '/data-view';
            case 'EMPLOYEE':
                return '/employee/schedule';
            default:
                return '/default-route';
        }
    };

    const url = getRootUrl();

    return <Navigate to={url} />;
};

export default Root;
